import _ from "lodash";
import { api } from "../../server/request";
import { handleError, handleResponse } from "../../actions/responseUtil";

const ACTION_TYPES = {
    SET_LOADING: "starlinkDashboard/setLoading",
    GET_SERVICE_LINES: "starlinkDashboard/getServiceLines",
    GET_WARNINGS: "starlinkDashboard/getWarnings",
    GET_STARLINK_LAST_LOCATION: "starlinkDashboard/getStarlinkLastLocation",
    GET_STARLINK_MAP_TELEMETRY: "starlinkDashboard/getStarlinkMapTelemetry",
    GET_ALL_SERVICE_LINES_SUBSCRIPTION: "starlinkDashboard/getAllServiceLineSubscriptions",
    GET_SERVICE_LINES_BY_SUBSCRIPTION: "starlinkDashboard/getServiceLinesBySubscription",
    GET_SUSBCRIBED_SERVICE_LINES:  "starlinkDashboard/getSubscribedServiceLines"
}

const initialState = {
    serviceLines: [],
    totalServiceLines: 0,
    totalUsageGB: 0,
    totalOverageGB: 0,
    totalOverage: 0,
    totalUserTerminals: 0,
    totalOnlineTerminals: 0,
    totalActiveAlerts: 0,
    totalAlertingTerminals: 0,
    warnings: [],
    gettingServiceLines: false,
    gettingWarnings: false,
    starlinkLastLocations:[],
    starlinkMapTelemetry:[],
    getAllServiceLinesSubscription:[],
    getServiceLinesBySubscription:[],
    getSubscribedServiceLines:[]
}
export function starlinkDashboardReducer(state: any = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.GET_SERVICE_LINES: {
            const data = action.payload.data;
            return {
                ...state,
                serviceLines: data,
                totalServiceLines: data?.totalCount ? data?.totalCount : 0,
                totalUsageGB: data?.totalUsageGB ? data?.totalUsageGB : 0,
                totalOverageGB: data?.totalOverageGB ? data?.totalOverageGB : 0,
                totalOverage: data?.totalOverage ? data?.totalOverage : 0,
                totalUserTerminals: data?.totalUserTerminals ? data?.totalUserTerminals : 0,
                totalOnlineTerminals: data?.totalOnlineTerminals ? data?.totalOnlineTerminals : 0,
                totalActiveAlerts: data?.totalActiveAlerts ? data?.totalActiveAlerts : 0,
                totalAlertingTerminals: data?.totalAlertingTerminals ? data?.totalAlertingTerminals : 0,
            }
        }
        case ACTION_TYPES.GET_WARNINGS: {
            const warnings = action.payload?.data?.rows?.map(row => row[0])?.filter(warning => warning);
            return {
                ...state,
                warnings: warnings || [],
            }
        }
        case ACTION_TYPES.GET_STARLINK_LAST_LOCATION: {
            const locations = action.payload?.data?.rows;
            return {
                ...state,
                starlinkLastLocations: locations || [],
            }
        }
        case ACTION_TYPES.GET_ALL_SERVICE_LINES_SUBSCRIPTION: {
            const data = action.payload?.data;
            return {
                ...state,
                getAllServiceLinesSubscription: data || [],
            }
        }
         case ACTION_TYPES.GET_SERVICE_LINES_BY_SUBSCRIPTION: {
            const data = action.payload?.data;
            return {
                ...state,
                getServiceLinesBySubscription: data || [],
            }
        } 
          case ACTION_TYPES.GET_SUSBCRIBED_SERVICE_LINES: {
            const data = action.payload?.data;
            return {
                ...state,
                getSubscribedServiceLines: data || [],
            }
        }
        case ACTION_TYPES.GET_STARLINK_MAP_TELEMETRY: {
            const data = action.payload?.data;
            return {
                ...state,
                starlinkMapTelemetry: data || [],
            }
        }
        case ACTION_TYPES.SET_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        default:
            return state
    }
}

export const getServiceLinesByStatusAPI = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
    let _params = {
        dpIds:  Array.isArray(parameters?.dpIds) ? parameters?.dpIds?.map(dpId => `'${dpId}'`)?.join(',') : "''",
        subscriptionStatus: "'all'",
        accountNumbers: parameters?.accountNumbers?.length ? parameters?.accountNumbers?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines: parameters?.serviceLines
    }
    const data = {
        query: `OPT_GET_ACTIVE_SERVICE_LINES`,
        named: true,
        format: 'json',
        parameters: _params
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINES_BY_SUBSCRIPTION)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}

export interface getServiceLinesParameters {
    dpIds: string[];
    startDate: string;
    endDate: string;
    searchText: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
    source:string;
    usageSource:string;
    serviceLines: string[];
    accounts: string[];
    offlineServiceLines:boolean;
    noTerminals:boolean;
    offlineTerminals:boolean;
    alertingTerminals:boolean;
    mobilePriorityEnabled: boolean;
    mobilePriorityDisabled: boolean;
    onlineServiceLines:boolean;
    onlineTerminals: boolean;
}

export const getServiceLines = (parameters: getServiceLinesParameters, signal: AbortSignal) => (dispatch) => {
     if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    dispatch({ type: ACTION_TYPES.GET_SERVICE_LINES, payload: { data: { rows: [[[], 0]] } } })
    let _parameters: any = {
        dpIds: parameters?.dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
        searchText: parameters?.searchText,
        sortBy: parameters?.sortBy,
        sortOrder: parameters?.sortOrder,
        limit: parameters?.limit,
        source:parameters?.source,
        usageSource: parameters?.usageSource,
        offset: (parameters?.page - 1) * parameters?.limit,
        offlineServiceLines: parameters?.offlineServiceLines ? parameters?.offlineServiceLines : false,
        onlineServiceLines: parameters?.onlineServiceLines ? parameters?.onlineServiceLines : false,
        noTerminals: parameters?.noTerminals ? parameters?.noTerminals : false,
        offlineTerminals: parameters?.offlineTerminals ? parameters?.offlineTerminals : false,
        onlineTerminals: parameters?.onlineTerminals ? parameters?.onlineTerminals : false,
        alertingTerminals: parameters?.alertingTerminals ? parameters?.alertingTerminals : false,
        disableMobilePriority: parameters?.mobilePriorityDisabled ? parameters?.mobilePriorityDisabled : false,
        enableMobilePriority : parameters?.mobilePriorityEnabled ? parameters?.mobilePriorityEnabled : false,

    };
    const data = {
        query: `OPT_GET_SERVICE_LINES_SPORT_V5`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data, signal)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINES)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export interface getStarlinkCloudWarningsParameters {
    dpIds: string[];
}

export const getStarlinkCloudWarnings = (parameters: getStarlinkCloudWarningsParameters) => (dispatch) => {
    if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
    let _parameters: any = {
        dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
    };
    const data = {
        query: `GET_STARLINK_CLOUD_WARNINGS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_WARNINGS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}

export const getStarlinkLastLocation = (parameters, signal: AbortSignal) => (dispatch) => {
    if (parameters?.serviceLines.includes('All') ) return;
    if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
    dispatch({ type: ACTION_TYPES.GET_STARLINK_LAST_LOCATION, payload: { data: {  } } })
    let _parameters = {
          dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
          accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
          serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
          "is_edge": "false",
          "is_starlink": "true",
          "is_edge_starlink":"false",
          source: parameters?.source,
          start_date: parameters?.startDate,
          end_date: parameters?.endDate,
          usageSource: parameters?.usageSource,
          offline_service_lines: parameters?.offlineServiceLines ? parameters?.offlineServiceLines : false,
          no_terminals:parameters?.noTerminals ? parameters?.noTerminals : false,
          offline_terminals: parameters?.offlineTerminals ? parameters?.offlineTerminals : false,
          alerting_terminals: parameters?.alertingTerminals ? parameters?.alertingTerminals : false,
          online_service_lines: parameters?.onlineServiceLines ? parameters?.onlineServiceLines : false,
          online_terminals: parameters?.onlineTerminals ? parameters?.onlineTerminals : false,
          disable_mobile_priority: parameters?.mobilePriorityDisabled ? parameters?.mobilePriorityDisabled : false,
          enable_mobile_priority : parameters?.mobilePriorityEnabled ? parameters?.mobilePriorityEnabled : false,
          searchText: parameters?.searchText 
        
      }
    const data = {
        query: `OPT_GET_STARLINK_MAPS_SL_LIST_V3`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data, signal)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_LAST_LOCATION)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}

export const getStarlinkMapTelemetry = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
    let _parameters = {
        userTerminalId: parameters?.userTerminalId, 
      }
    const data = {
        query: `OPT_GET_STARLINK_MAPS_UT_TELEMETRY`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_MAP_TELEMETRY)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}

export const getAllServiceLineSubscriptionAPI = (signal: AbortSignal) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
  
    const data = {
        query: `GET_ACTIVE_SERVICE_LINES`,
        named: true,
        format: 'json',
    }
    api
        .postRequestOut(`/store/pg/query`, data, signal)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ALL_SERVICE_LINES_SUBSCRIPTION)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}
export const clearComponentData = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_SERVICE_LINES, payload: { data: { rows: [[[], 0]] } } })
}


export const getSubscribedServiceLinesAPI = (parameters) => (dispatch) => {
      if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: true } });
    let _params = {
        dpIds:  Array.isArray(parameters?.dpIds) ? parameters?.dpIds?.map(dpId => `'${dpId}'`)?.join(',') : "''",
        subscriptionStatus: parameters?.subscriptionStatus,
        accountNumbers: parameters?.accountNumbers?.length ? parameters?.accountNumbers?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines: parameters?.serviceLines
    }
    const data = {
        query: `OPT_GET_ACTIVE_SERVICE_LINES`,
        named: true,
        format: 'json',
        parameters: _params
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SUSBCRIBED_SERVICE_LINES)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingWarnings: false } });
        });
}